// extracted by css-extract-rspack-plugin
export default {"navigator":"Navi__navigator--ygSht","body":"Navi__body--gBjA7","items":"Navi__items--DkSyk","item":"Navi__item--v4MS5","submitItem":"Navi__submitItem--pyZPw"};